import React, {
  useState,
  useEffect,
  useRef,
  FC,
  ReactNode,
  useContext
} from "react";
import {
  Container,
  Label,
  Wrapper,
  Note,
  Name,
  PersonalDetails
} from "./styles";
import { Context } from "@components/useContext/context";
import { Flex } from "@acko-tech/building-blocks.ui.common";

const EditDetails = ({ ...props }) => {
  const {
    note,
    nomineeName,
    age,
    relationship,
    placeholder,
    is_visible
  } = props || {};
  const { isDesktop } = useContext(Context);
  return is_visible ? (
    <Wrapper>
        <Container>
          <Flex flexDirection="column" style={{ gap: "20px"}}>
            <Name>
              <div style={{ fontSize: "12px", fontWeight: "400" }}>Name</div>
              <div>{nomineeName}</div>
            </Name>
            <PersonalDetails>
              <div>
                <div style={{ fontSize: "12px", fontWeight: "400" }}>Age</div>
                <div>{age}</div>
              </div>
              <div style={{ paddingRight: "50px" }}>
                <div style={{ fontSize: "12px", fontWeight: "400" }}>Relationship</div>
                <div>{relationship}</div>
              </div>
            </PersonalDetails>
          </Flex>
        </Container>
        <Label>{placeholder}</Label>
      {note && <Note isDesktop={isDesktop}>{note}</Note>}
    </Wrapper>
  ):null;
};

export default EditDetails;
